import api from "@services/apiList";
import instance from "@services/services";
import {
  MasterDataType,
  MasterTableDataType,
  PackageCptListType,
  SaveResponseType,
  SearchParamsType,
} from "./Types";
import { ResponseType } from "Types/ServicesType/servicesType";
const { MastersApi } = api;
export const getMastersTableData = async (
  params: SearchParamsType
): Promise<
  ResponseType<{ totalCount: number; packageDto: MasterTableDataType[] }>
> => {
  const result = await instance.post(`${MastersApi.getPackageList}`, params);
  return result.data;
};

export const saveMasterData = async (
  params: MasterDataType[]
): Promise<ResponseType<SaveResponseType>> => {
  const result = await instance.post(
    `${MastersApi.saveORUpdatePackage}`,
    params
  );
  return result.data;
};

export const updatePackage = async (
  payload: Array<{ clinicId: number; packageId: number; packageStatus: number }>
): Promise<ResponseType<string>> => {
  const result = await instance.post(
    `${MastersApi.updatePackageStatus}`,
    payload
  );
  return result.data;
};

export const getPackageCptList = async (params: {
  clinicId: number;
  searchText?: string;
  packageId: number;
}): Promise<ResponseType<PackageCptListType[]>> => {
  const result = await instance.post(`${MastersApi.getPackageCptList}`, params);
  return result.data;
};

export const PackageCptSearch = async (params: {
  search: string;
  clinicId: number;
  groupId: number;
}): Promise<ResponseType<PackageCptListType[]>> => {
  const result = await instance.post(`${MastersApi.doctorCptDropdown}`, params);
  return result.data;
};
export const PackageNameSearch = async (params: {
  searchText: string;
  clinicId: number;
}): Promise<ResponseType<PackageCptListType[]>> => {
  const result = await instance.post(`${MastersApi.packageCptSearch}`, params);
  return result.data;
};

export const deletePackageCpt = async (params: {
  packageCptId?: number;
  packageId: number;
  clinicId: number;
  searchText: string;
}): Promise<ResponseType<SaveResponseType>> => {
  const result = await instance.post(`${MastersApi.deletePackageCpt}`, params);
  return result.data;
};
